export default "__VITE_ASSET__CKbYtu9H__"